export default __webpack_public_path__ + "static/chamberlain-828c478143796c4a472acaffd2c0c94a.jpg";